module.exports = __webpack_public_path__ + "static/media/axialDisease.30db3cbb.svg";